'use strict';
angular.module('TurneroApp').component('coDarTurnoTelefonico', {
	bindings: {
		centroAtencionSeleccionado: '<'
	},
	controller: [
		 '$window',
		 'turnosService',
		 '$state',
		 '$rootScope',
		 '$scope',
		 'utilsService',
		 '$element',
		 'TurneroAppConstant',
		 'tramiteService',
		 'centrosAtencionService',
		 'agendaService',
		 function ($window, turnosService, $state, $rootScope, $scope, utilsService, $element, TurneroAppConstant, tramiteService, centrosAtencionService, agendaService) {
		 	var ctrl = this;
            ctrl.Turno = {};
            ctrl.Dar_Turnos_Multiples = false;
		 	ctrl.permisos = TurneroAppConstant.Permisos;
		 	ctrl.Modalidades = TurneroAppConstant.Modalidades;
		 	ctrl.limpiarMemoria = function () {
		 		ctrl.personaConfig = {
		 			numero_seccion: 2
		 		}

		 		ctrl.Filtro = {
		 			Agenda: null,
		 			Tramite: null,
		 			Centro: null
		 		}
		 		ctrl.showAgendas = false;
		 		ctrl.Turno.calendario = false;
		 		ctrl.TurnoInfo = {};
		 		$rootScope.$broadcast('LimpiarPersonas', null);
		 	}

		 	$scope.$on('cambioPersonaSeleccionada', function (event, personaSeleccionada) {
		 		ctrl.Ciudadano = null;
		 		if (personaSeleccionada) {
		 			ctrl.Ciudadano = personaSeleccionada;
		 			ctrl.TurnoInfo.Ciudadano = personaSeleccionada;
		 		}
		 	});

		 	ctrl.$onChanges = function () {
		 		ctrl.limpiarMemoria();
		 		ctrl.cargaCombos();

		 	};

		 	ctrl.cargaCombos = function () {
		 		ctrl.promiseTramite = tramiteService.Get_Tramite_Telef_Combo().$promise.then(function (result) {
		 			ctrl.Tramites = result.Data;
		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		})
		 	}

		 	ctrl.cargarCentros = function (tramite) {
		 		centrosAtencionService.Get_Centros_Atencion_Telef_Combo({ 'Id_Tramite_Relevado': tramite.id }).$promise.then(function (result) {
		 			ctrl.Centros = result.Data;
		 			ctrl.Filtro.Centro = null;
		 			ctrl.Filtro.Agenda = null;
		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		})
		 	}

		 	ctrl.cargarAgendas = function (centro, tramite) {
		 		ctrl.Filtro.Agenda = null;
		 		agendaService.Get_Agenda_Telef_Combo({ 'Id_Centro_Atencion': centro.id, 'Id_Tramite_Relevado': tramite.id }).$promise.then(function (result) {
		 			ctrl.Agendas = result.Data;
		 			if (ctrl.Agendas.length == 1) {
		 				ctrl.Filtro.Agenda = ctrl.Agendas[0];
		 			}

		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		})
		 	}

		 	ctrl.verFechasCalendario = function (bool) {
		 		ctrl.calendarioReadOnly = null;
		 		ctrl.DatosTurno = null;
		 		ctrl.Agenda = {};
		 		ctrl.DatosTurno = ctrl.Turno;
		 		ctrl.Agenda.Agenda = ctrl.Filtro.Agenda
		 		ctrl.DatosTurno.Agenda = ctrl.Agenda.Agenda
		 		ctrl.Agenda.Tramite = ctrl.Filtro.Tramite
		 		ctrl.DatosTurno.Tramite = ctrl.Agenda.Tramite
		 		ctrl.Agenda.CentroSeleccionado = ctrl.Filtro.Centro
		 		ctrl.DatosTurno.centroSeleccionado = ctrl.Agenda.CentroSeleccionado
		 		if (ctrl.Ciudadano && ctrl.Ciudadano.Datos_RegistroCivil) {
		 			ctrl.Ciudadano.Datos_RegistroCivil.NombreAs = ctrl.Ciudadano.Datos_RegistroCivil.Nombre.split(',')[1].trim();
		 			ctrl.Ciudadano.Datos_RegistroCivil.ApellidoAs = ctrl.Ciudadano.Datos_RegistroCivil.Nombre.split(',')[0].trim();
		 		}
		 		ctrl.calendarioReadOnly = bool;
		 		ctrl.mostrarCalendario = true;
		 	}


		 	$element.find('input').on('keydown', function (ev) {
		 		if (ctrl.searchTerm.text) {
		 			ctrl.searchTerm = ctrl.searchTerm;
		 		} else if (ctrl.searchTermCentro.text) {
		 			ctrl.searchTermCentro = ctrl.searchTermCentro;
		 		} else {
		 			ctrl.searchTermAgenda = ctrl.searchTermAgenda;
		 		}

		 		ev.stopPropagation();
		 	});

		 	ctrl.searchTerm = {
		 		text: ''
		 	};
		 	ctrl.clearSearchTerm = function () {
		 		ctrl.searchTerm = {
		 			text: ''
		 		};
		 	};
		 	ctrl.searchTermCentro = {
		 		text: ''
		 	};
		 	ctrl.clearSearchTermCentro = function () {
		 		ctrl.searchTermCentro = {
		 			text: ''
		 		};
		 	};
		 	ctrl.searchTermAgenda = {
		 		text: ''
		 	};
		 	ctrl.clearSearchTermAgenda = function () {
		 		ctrl.searchTermAgenda = {
		 			text: ''
		 		};
		 	};

		 	ctrl.ignoreAccents = function (item) {
		 		if (!ctrl.searchTerm.text)
		 			return true;
		 		var text = utilsService.removeAccents(item.text.toLowerCase())
		 		var search = utilsService.removeAccents(ctrl.searchTerm.text.toLowerCase());
		 		return text.indexOf(search) > -1;
		 	};

		 	ctrl.ocultarCalendario = function (bool) {
		 		ctrl.DatosTurno = {};
		 		ctrl.calendarioReadOnly = true;
		 		ctrl.mostrarCalendario = bool;
		 	}

		 	$scope.$on('cancelarConfirmacion', function (event, bool) {
		 		ctrl.mostrarConfirmacion = bool;
		 		ctrl.mostrarCalendario = false;
		 		ctrl.limpiarMemoria()
		 	});

		 	ctrl.MostrarConfirmacion = function (data) {
		 		ctrl.calendarioReadOnly = false;
		 		ctrl.mostrarCalendario = false;
		 		ctrl.DatosTurno.Turno = data;
		 		ctrl.mostrarConfirmacion = true;
		 		$scope.$apply();
		 	}

		 	$scope.$on('volverACalendario', function (event, bool) {
		 		ctrl.mostrarCalendario = bool;
		 		ctrl.calendarioReadOnly = bool;
		 		ctrl.mostrarConfirmacion = !bool;
		 		$scope.$apply();

		 	})
		 }],
	template: require('./asistencia_Telefonico.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/asistencia_TelefonicoComponent.js